// extracted by mini-css-extract-plugin
export default {"title":"saa-z","warning":"taa-z","sizeOptionsLegendText":"uaa-z"};